import templateUrl from 'emun.order/ticket-fieldset.htm'
import controller from 'emun.order/ticket-fieldset.controller'

export default {
    bindings: {
		ticket: '='
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};